import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ea671ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }, " ·订单数据 ", -1))
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }, " ·平台当前累积数据 ", -1))
const _hoisted_8 = { class: "high-light" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_10 = { class: "high-light" }
const _hoisted_11 = { class: "high-light" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty } from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'newMediaTwo',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const field = ref("粉丝数");
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序
// const orderPayRateAsc = ref(false); // 下单成功率升序
const distributorOrderPayCountAsc = ref(false); // 分销商-下单成功量升序

const visible = ref(false);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/nm/sales/total",
    method: "POST",
    data: {
      startDay: route?.params.time,
      endDay: route?.params.time,
      groupUnit: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 产品排行
const productsList = ref<any>([]);

const getProductsData = async () => {
  const res = await request({
    url: "/api/nm/sales/total-sales ",
    method: "POST",
    data: {
      startDay: route?.params.time,
      endDay: route?.params.time,
      groupUnit: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    productsList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

const handleChange = (name: number) => {
  if (name === 0) {
    field.value = "粉丝数";
  } else if (name === 1) {
    field.value = "曝光数";
  }
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(pageData.value?.time).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.baseValueDataList, (childRenItem, childRenIndex) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: childRenItem.name,
                size: "large",
                class: "bold",
                "title-style": { width: '120px', flex: 'inherit' },
                key: childRenIndex
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                    ? _unref(formatPercentage)(childRenItem.value)
                    : childRenItem.value) + "（环比：", 1),
                    _createElementVNode("span", {
                      style: _normalizeStyle({
                    color: childRenItem.percentage >= 0 ? 'red' : 'green',
                  })
                    }, _toDisplayString(`${
                      childRenItem.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                    _createTextVNode("） ")
                  ])
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128)),
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value[
              '平台当前累积数据'
            ]?.baseValueDataList, (childRenItem, childRenIndex) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: childRenItem.name,
                size: "large",
                class: "bold",
                "title-style": { width: '120px', flex: 'inherit' },
                key: childRenIndex
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                    ? _unref(formatPercentage)(childRenItem.value)
                    : childRenItem.value) + "（环比：", 1),
                    _createElementVNode("span", {
                      style: _normalizeStyle({
                    color: childRenItem.percentage >= 0 ? 'red' : 'green',
                  })
                    }, _toDisplayString(`${
                      childRenItem.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                    _createTextVNode("） ")
                  ])
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_9,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          onChange: handleChange,
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "粉丝数" }, {
              default: _withCtx(() => [
                (!productsList.value[field.value]?.baseValueDataList.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value[field.value]
                ?.baseValueDataList, (childRenItem, childRenIndex) => {
                  return (_openBlock(), _createBlock(_unref(Cell), {
                    title: childRenItem.name,
                    size: "large",
                    class: "bold",
                    "title-style": { width: '120px', flex: 'inherit' },
                    key: childRenIndex
                  }, {
                    value: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, [
                        _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                      ? _unref(formatPercentage)(childRenItem.value)
                      : childRenItem.value) + "（环比：", 1),
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                      color: childRenItem.percentage >= 0 ? 'red' : 'green',
                    })
                        }, _toDisplayString(`${
                        childRenItem.percentage >= 0 ? "+" : ""
                      }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                        _createTextVNode("） ")
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "视频曝光数" }, {
              default: _withCtx(() => [
                (!productsList.value[field.value]?.baseValueDataList.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value[field.value]
                ?.baseValueDataList, (childRenItem, childRenIndex) => {
                  return (_openBlock(), _createBlock(_unref(Cell), {
                    title: childRenItem.name,
                    size: "large",
                    class: "bold",
                    "title-style": { width: '120px', flex: 'inherit' },
                    key: childRenIndex
                  }, {
                    value: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, [
                        _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                      ? _unref(formatPercentage)(childRenItem.value)
                      : childRenItem.value) + "（环比：", 1),
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                      color: childRenItem.percentage >= 0 ? 'red' : 'green',
                    })
                        }, _toDisplayString(`${
                        childRenItem.percentage >= 0 ? "+" : ""
                      }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                        _createTextVNode("） ")
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})